// Turkse teksten van aanmelden en abonnement (zie billingApp.nl.ts).
export const appBillingTr = {
    signup: {
        steps: ['Hoş geldin', 'Hesap', 'Onay', 'Hane', 'Üyeler', 'Modüller', 'Pano', 'Hazır'],
        stepOf: 'Adım {n} / {total}: {name}',
        welcomeTitle: 'AMUMIN Family Board’a hoş geldin',
        welcomeBody: 'Haneniz için sakin bir pano: takvim, görevler ve daha fazlası, duvardaki bir tablette ve bu uygulamada.',
        trialLine: 'İlk ay ücretsiz. Şimdi ödeme bilgisi girmen gerekmiyor.',
        languageLabel: 'Hangi dilde devam etmek istersin?',
        start: 'Başla',
        closedTitle: 'Kayıt henüz açık değil',
        closedBody: 'Yakında açılıyoruz. Bekleme listesine yazıl, sana bir davet gönderelim.',
        closedLink: 'Bekleme listesine git',
        haveAccount: 'Zaten bir hesabın var mı?',
        login: 'Giriş yap',
        accountTitle: 'Hesabın',
        accountBody: 'Bununla giriş yaparsın. E-posta adresini yalnızca hesabın için kullanırız, asla reklam için değil.',
        name: 'Adın',
        nameHint: 'Pano sana böyle seslenir. Sonra değiştirebilirsin.',
        nameRequired: 'Adını gir.',
        email: 'E-posta adresi',
        method: 'Nasıl giriş yapmak istersin?',
        methodPassword: 'Şifreyle',
        methodLink: 'Bana bir bağlantı gönder',
        methodLinkHint: 'E-postayla bir kod ve bir düğme alırsın. Daha sonra istediğin zaman bir şifre seçebilirsin.',
        priceLine: '1 ay ücretsiz, sonra ayda {price}. İstediğin zaman iptal edebilirsin.',
        priceLinePlaceholder: '1 ay ücretsiz, sonra aylık ödersin. Fiyatı süre bitmeden çok önce öğrenirsin. İstediğin zaman iptal edebilirsin.',
        termsBefore: 'Şunları kabul ediyorum:',
        termsLink: 'koşullar',
        termsAnd: 've',
        privacyLink: 'gizlilik bildirimi',
        termsRequired: 'Devam etmek için bunu işaretle.',
        createAccount: 'Hesap oluştur',
        verifyTitle: 'E-posta adresini onayla',
        verifyIntro: '{email} adresine bir kod gönderdik. Kodu aşağıya yaz ya da e-postadaki düğmeye tıkla.',
        verifyHint: 'E-posta gelmedi mi? İstenmeyen klasörüne de bak ya da aşağıdan yeni bir kod iste.',
        otherEmail: 'Başka bir e-posta adresi',
        linkBusy: 'E-posta adresin onaylanıyor…',
        linkVerifiedTitle: 'E-posta adresin onaylandı',
        linkVerifiedBody: 'Deneme ayın başladı. Başladığın tarayıcıda devam et ya da buradan giriş yap.',
        linkInvalid: 'Bu bağlantının süresi dolmuş ya da zaten kullanılmış. Giriş yap ya da yeniden kayıt ol.',
        modulesTitle: 'Neleri kullanmak istersin?',
        modulesBody: 'Her şey isteğe bağlı. Sizin hane türünüz için bunlar zaten açık; istediğini aç ya da kapat. Bunu daha sonra her zaman Ayarlar › Modüller bölümünden değiştirebilirsin.',
        profileTitle: 'İnanç, yemek ve özel günler',
        profileBody: 'Yalnızca istersen. Kendin seçersin ve bunun için ayrıca onay verirsin.',
        profileButton: 'Seç',
        boardTitle: 'Pano olarak bir tablet',
        boardBody: 'Duvara bir tablet koy ve QR koduyla bağla. Yanında tablet yok mu? Bunu daha sonra Ayarlar › Tabletler bölümünden de yapabilirsin.',
        boardQr: 'QR koduyla bağla',
        boardCode: 'Bir kodla bağla',
        doneTitle: 'Hoş geldin, her şey hazır',
        doneTrial: 'Deneme ayın {date} tarihine kadar (bu gün dahil) sürüyor.',
        doneNext: [
            'Bitişinden bir hafta önce sana bir hatırlatma göndeririz.',
            'Sonrasında devam etmek mi istiyorsun? Ödeme bilgilerini Ayarlar › Abonelik bölümünde ekle. Hiçbir şey yapmazsan her şeyi görmeye devam edebilirsin ama artık değiştiremezsin.',
            'İstediğin zaman iptal edebilirsin. Hiçbir şeyi kendiliğinden silmeyiz.',
        ],
        toApp: 'Uygulamaya git',
    },
    page: {
        title: 'Abonelik',
        settingsHint: 'Deneme ayı, ödeme ve faturalar',
        offTitle: 'Henüz abonelik yok',
        offBody: 'AMUMIN Family Board’u şu an aboneliksiz kullanıyorsun.',
        noneTitle: 'Abonelik gerekmiyor',
        noneBody: 'Bu aile panosunun aboneliği yok.',
        status: {
            trial: 'Deneme ayı',
            active: 'Etkin',
            past_due: 'Ödeme başarısız',
            paused: 'Duraklatıldı',
            cancelled: 'İptal edildi',
            expired: 'Yalnızca görüntüleme',
        },
        trialLeft: '{n} gün daha ücretsiz, {date} tarihine kadar (bu gün dahil).',
        trialLastDay: 'Bugün ({date}) son ücretsiz günün.',
        activeUntil: '{date} tarihine kadar ödendi.',
        activeOpen: 'Aboneliğin devam ediyor.',
        cancelledUntil: 'İptal edildi. Her şey {date} tarihine kadar (bu gün dahil) çalışmaya devam eder.',
        expiredBody: 'Deneme ayın bitti. Her şey hâlâ yerinde; ödeme yaptıktan sonra yeniden değişiklik yapabilirsin.',
        pastDueBody: 'Son ödeme başarısız oldu. Ödeme bilgilerini yeniden ekle.',
        pausedBody: 'AMUMIN aboneliğini kısa bir süre duraklattı. Her şey normal çalışıyor.',
        plan: 'Plan',
        perMonth: 'Ayda {price}',
        pricePlaceholder: 'Fiyat yakında',
        payment: 'Ödeme bilgileri',
        paymentNone: 'Henüz ödeme bilgisi yok.',
        paymentSet: 'Otomatik ödeme talimatı hazır.',
        addPayment: 'Ödeme bilgisi ekle',
        soon: 'Yakında: iDEAL ile ödeme, ardından otomatik ödeme talimatı.',
        checkoutTitle: 'Ödeme bilgisi ekle',
        checkoutBody: 'İlk ayı iDEAL ile ödersin. Sonra her ay otomatik olarak tahsil ederiz. İstediğin zaman iptal edebilirsin.',
        startNow: 'Hizmetin hemen devam etmesini istiyorum. 14 gün içinde cayarsam, yalnızca kullandığım günlerin ücretini öderim.',
        startNowRequired: 'Devam etmek için bunu işaretle.',
        toPayment: 'Ödemeye geç',
        checkoutOpen: 'Zaten devam eden bir ödeme var. Önce onu tamamla ya da bir saat sonra tekrar dene.',
        paidReturn: 'Teşekkürler. Ödeme ulaşır ulaşmaz burada görürsün.',
        invoices: 'Faturalar',
        invoicesNone: 'Henüz fatura yok.',
        invoiceStatus: {
            open: 'Açık',
            paid: 'Ödendi',
            failed: 'Başarısız',
            refunded: 'İade edildi',
            void: 'Geçersiz',
        },
        invoiceLine: '{number} · {period} · {amount}',
        cancel: 'Aboneliği iptal et',
        cancelTitle: 'Abonelik iptal edilsin mi?',
        cancelBody: 'Her şey {date} tarihine kadar (bu gün dahil) çalışmaya devam eder. Sonra her şeyi görmeye devam edebilirsin ama artık değiştiremezsin. Hiçbir şeyi silmeyiz.',
        cancelConfirm: 'Evet, iptal et',
        keep: 'Vazgeç',
        cancelDone: 'Aboneliğin iptal edildi.',
        resume: 'Yine de devam et',
        resumeDone: 'Güzel, aboneliğin devam ediyor.',
        onlyOwner: 'Yalnızca hesap sahibi ödeme yapabilir veya iptal edebilir.',
        deleteHint: 'Her şeyi silmek mi istiyorsun? Bunu Ayarlar › Verilerin bölümünden yapabilirsin.',
    },
    banner: {
        expiredTitle: 'Deneme ayın bitti',
        expiredBody: 'Her şeyi hâlâ görebilirsin. Yeniden ekleme ve değişiklik yapmak için ödeme bilgisi ekle.',
        pay: 'Öde',
        readOnly: 'Deneme ayın bitti: ödeme yaptıktan sonra yeniden değişiklik yapabilirsin.',
    },
    terms: {
        title: 'Koşullar (taslak)',
        intro: 'Bu bir taslaktır. Kesin genel koşullar, kayıtlar açılmadan önce burada yer alacak.',
        points: [
            'İlk ay ücretsiz. Bunun için ödeme bilgisi vermen gerekmiyor.',
            'Sonrasında aylık ya da yıllık, peşin ödersin. İstediğin zaman iptal edebilirsin; abonelik o zaman ödenen dönemin sonuna kadar sürer.',
            'Ödeme yapılmadan biten deneme ayından sonra her şeyi görmeye devam edebilirsin ama artık değiştiremezsin. Hiçbir şeyi kendiliğinden silmeyiz.',
            'Tüketici olarak, ödemeye başladığın andan itibaren 14 günlük cayma hakkın var.',
            'Verilerini nasıl işlediğimiz gizlilik bildiriminde yazıyor.',
        ],
    },
};
//# sourceMappingURL=billingApp.tr.js.map